import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMillVibration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 60,
	viewBox: "0 0 100.0 60.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 100.0 0.0 L 80.0 60.0 L 20.0 60.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 25.0 0.0 L 8.0 25.0 M 75.0 0.0 L 92.0 25.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 30,
			rx: 20,
			ry: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 50.0 25.0 L 60.0 25.0 M 40.0 35.0 L 50.0 35.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 50.0 22.5 L 50.0 27.5 L 42.0 25.0 Z M 50.0 32.5 L 50.0 37.5 L 58.0 35.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgMillVibration;
